import gql from 'graphql-tag';

export const GET_DEAL_BUILDERS = gql`
  query GetDealBuilders($vendorOpportunityId: ID!) {
    dealBuilder {
      getDealBuilders(vendorOpportunityId: $vendorOpportunityId) {
        success
        error
        entity {
          proposalId
          proposal {
            createdDateTime
            businessName
            firstName
            lastName
            saleType
            amountRequested
            status
            salesPersonName
            vendorOpportunityId
            proposalId
            settings {
              configuration {
                formData
                builder
                pricing
                productsConfig
                commonProductsConfiguration
              }
            }
          }
          proposalContacts {
            proposalContactsId
            proposalId
            ownerPgId
            accountContactId
          }
          proposalEquipments {
            proposalEquipmentsId
            proposalId
            equipmentId
          }
          quote {
            quoteId
            attributes {
              key
              description
              value
            }
            feesTotal
            fees {
              type
              amount
              isTaxable
              amountType
              description
              equipmentId
              isFromCommonRules
              price {
                total
                markup
                netPrice
                discount
                salesTax
                markupType
                retailPrice
                discountType
                salesTaxType
                wholesalePrice
              }
            }
            aftermarketProducts {
              type
              description
              cost
              equipmentId
            }
            aftermarketProductsTotal
            rebates {
              description
              amount
              equipmentId
            }
            rebatesTotal
            cashBackAmounts {
              description
              amount
              equipmentId
            }
            cashBackAmountsTotal
            tradeValueNet
            tradeValueGross
            tradeValueOwed
            equipment {
              equipmentId
              externalId
              vin
              stockNumber
              cost
              attributes {
                key
                description
                value
              }
              price {
                total
                markup
                netPrice
                discount
                salesTax
                markupType
                retailPrice
                discountType
                salesTaxType
                wholesalePrice
              }
            }
            equipmentSubtotal
            deposit {
              type
              value
              notes
            }
            createdDateTime
            modifiedDateTime
          }
        }
      }
    }
  }
`;
